import { render } from "./BioDataCard.vue?vue&type=template&id=d5421fb8&scoped=true"
import script from "./BioDataCard.vue?vue&type=script&lang=js"
export * from "./BioDataCard.vue?vue&type=script&lang=js"

import "./BioDataCard.vue?vue&type=style&index=0&id=d5421fb8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5421fb8"]])

export default __exports__